import config from '@/config/index'

    // /** 发起签约截止日期 / 合同有效日期范围最长天数（PC 端） */
    // launchDateRangeMaxDays: 45,
    // /** 签约截止日期默认跨度：今天起 N 天（PC 端） */
    // launchSignDefaultDays: 7,

/** 签约截止日期范围最长天数（PC 端） */
export const LAUNCH_DATE_RANGE_MAX_DAYS = 45

/** 合同有效日期：不限制天数（传 null 给 normalize 系列方法） */
export const LAUNCH_EFFECTIVE_DATE_MAX_DAYS = null

/** 签约截止日期默认跨度天数（PC 端，可在 config/index.js 修改） */
export const LAUNCH_SIGN_DEFAULT_DAYS = 7

function hasLaunchDateRangeLimit(maxDays) {
    return maxDays != null && maxDays > 0
}

export function parseDateOnly(str) {
    if (!str) return null
    const normalized = String(str).trim().slice(0, 10).replace(/-/g, '/')
    const date = new Date(normalized)
    if (Number.isNaN(date.getTime())) return null
    date.setHours(0, 0, 0, 0)
    return date
}

export function formatDateOnly(date) {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const d = String(date.getDate()).padStart(2, '0')
    return `${y}-${m}-${d}`
}

export function addDays(dateStr, days) {
    const date = parseDateOnly(dateStr)
    if (!date) return dateStr || ''
    date.setDate(date.getDate() + days)
    return formatDateOnly(date)
}

export function getDateRangeDayCount(startStr, endStr) {
    const start = parseDateOnly(startStr)
    const end = parseDateOnly(endStr)
    if (!start || !end) return 0
    return Math.floor((end.getTime() - start.getTime()) / 86400000) + 1
}

export function minDateStr(a, b) {
    if (!a) return b || ''
    if (!b) return a || ''
    return parseDateOnly(a).getTime() <= parseDateOnly(b).getTime() ? a : b
}

export function getLaunchDateRangeLimitMessage(maxDays = LAUNCH_DATE_RANGE_MAX_DAYS) {
    return `日期范围最长${maxDays}天`
}

/** 校验并修正 daterange 数组 [start, end] */
export function normalizeLaunchDateRange(range, maxDays = LAUNCH_DATE_RANGE_MAX_DAYS) {
    if (!Array.isArray(range)) {
        return { start: '', end: '', exceeded: false, message: '' }
    }
    const start = range[0] ? String(range[0]).slice(0, 10) : ''
    const end = range[1] ? String(range[1]).slice(0, 10) : ''
    if (!start || !end) {
        return { start, end, exceeded: false, message: '' }
    }
    if (!hasLaunchDateRangeLimit(maxDays)) {
        return { start, end, exceeded: false, message: '' }
    }
    const days = getDateRangeDayCount(start, end)
    if (days <= maxDays) {
        return { start, end, exceeded: false, message: '' }
    }
    return {
        start,
        end: addDays(start, maxDays - 1),
        exceeded: true,
        message: `${getLaunchDateRangeLimitMessage(maxDays)}，已自动调整结束日期`,
    }
}

/** 校验并修正独立 start/end 日期对 */
export function normalizeLaunchDatePair(startStr, endStr, maxDays = LAUNCH_DATE_RANGE_MAX_DAYS) {
    const start = startStr ? String(startStr).slice(0, 10) : ''
    let end = endStr ? String(endStr).slice(0, 10) : ''
    if (!start || !end) {
        return { start, end, exceeded: false, message: '' }
    }
    if (parseDateOnly(start).getTime() > parseDateOnly(end).getTime()) {
        end = start
    }
    if (!hasLaunchDateRangeLimit(maxDays)) {
        return { start, end, exceeded: false, message: '' }
    }
    const days = getDateRangeDayCount(start, end)
    if (days <= maxDays) {
        return { start, end, exceeded: false, message: '' }
    }
    return {
        start,
        end: addDays(start, maxDays - 1),
        exceeded: true,
        message: `${getLaunchDateRangeLimitMessage(maxDays)}，已自动调整结束日期`,
    }
}

/** 根据开始日期计算结束日期可选上限 */
export function getMaxEndDateByStart(startStr, globalMaxEnd, maxDays = LAUNCH_DATE_RANGE_MAX_DAYS) {
    if (!hasLaunchDateRangeLimit(maxDays)) return globalMaxEnd || ''
    if (!startStr) return globalMaxEnd || ''
    return minDateStr(globalMaxEnd, addDays(startStr, maxDays - 1))
}

export function getTodayDateStr() {
    const date = new Date()
    date.setHours(0, 0, 0, 0)
    return formatDateOnly(date)
}

/** 默认签约截止日期：今天 ~ 今天+N 天 */
export function getDefaultLaunchSignDateRange(defaultDays = LAUNCH_SIGN_DEFAULT_DAYS) {
    const start = getTodayDateStr()
    const end = addDays(start, defaultDays)
    return { start, end, range: [start, end] }
}

/** 已有值则沿用，否则返回默认签约截止日期 */
export function resolveLaunchSignDateRange(start, end, defaultDays = LAUNCH_SIGN_DEFAULT_DAYS) {
    const startStr = start ? String(start).slice(0, 10) : ''
    const endStr = end ? String(end).slice(0, 10) : ''
    if (startStr && endStr) {
        return { start: startStr, end: endStr, range: [startStr, endStr] }
    }
    return getDefaultLaunchSignDateRange(defaultDays)
}
